module.exports = __webpack_public_path__ + "static/media/Shelf Life Extender.eb206ebc.jpg";